import React, { useMemo } from "react"
import { MRT_ColumnDef } from "material-react-table";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Paper,
} from "@mui/material"
import MATERIAL_TABLE_CONTAINER from "../../../main_components/material_table/table_container";
import { relationships_purchase_order_post } from "../../../services/expenses/purchase_orders";
interface CustomTableProps {
  data: any;
  onCloseCustom: () => void;
}


const SUPPLIER_INVOICE_DETAIL: React.FC<CustomTableProps> = ({ data, onCloseCustom }) => {


  const columns: MRT_ColumnDef<any>[] = useMemo(
    () => [

      {
        header: "Concepto",
        accessorKey: "description",
        id: "description",
        size: 300,
      },
      {
        header: "Cantidad",
        accessorKey: "quantity",
        id: "quantity",
        size: 120,
      },

      {
        header: "Precio",
        accessorKey: "total",
        id: "total",
        size: 130,
      },
      {
        header: "Clave Unida",
        accessorKey: "clave_unidad",
        id: "clave_unidad",
        size: 140,
      },
      {
        header: "clave_prod_serv",
        accessorKey: "clave_prod_serv",
        id: "clave_prod_serv",
        size: 140,
      }
    ],

    []
  );

  if (data?.status_code == 1 || data?.status_code == 5) {
    return (
      <Box sx={{ bgcolor: "#f5f5f5", p: 2 }}>
        <h4>No hay factura relacionada.</h4>
      </Box>
    );
  }

  const totalPedido = data.details_invoice.concepts
    ?.map((item: any) => Number(item.total) || 0)
    .reduce((acc: number, curr: number) => acc + curr, 0);

  const handleRelationShips = async (id_status: number) => {
    try {
      await relationships_purchase_order_post(data.details_invoice.relationships[0].id_relationship_fk, { check_status_and_details: false, id_status: id_status })
      onCloseCustom()
    } catch (error: any) {
      alert(error.response.data.errorMessage.es)
    }
  }

  return (
    <Box sx={{ bgcolor: "#f5f5f5", p: 2 }}>
      <Paper sx={{ m: 2, p: 3 }}>
        {/* Tabla de Detalles */}
        <Grid container spacing={2} alignItems="stretch">
          {/* Información Proveedor */}
          <Grid item xs={12} md={4}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Información Proveedor
                </Typography>
                {[
                  ["Factura", data.details_invoice.relationships[0].folio + data.details_invoice.relationships[0].serie],
                  ["Fecha de la factura", data.details_invoice.relationships[0].invoice_date],
                  ["Nombre proveedor", data.details.proveedor.supplier_name],
                  ["RFC", data.details.proveedor.supplier_rfc],
                ].map(([label, value]) => (
                  <Grid container spacing={1} key={label}>
                    <Grid item xs={5}>
                      <Typography color="text.secondary">{label}:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography fontWeight="medium">{value}</Typography>
                    </Grid>
                  </Grid>
                ))}
              </CardContent>
            </Card>
          </Grid>

          {/* Dirección Entrega */}
          <Grid item xs={12} md={4}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Dirección Entrega
                </Typography>
                {[
                  ["Calle", data.address.street],
                  ["Colonia", data.address.neighborhood],
                  ["Ciudad", data.address.city],
                  ["Estado", data.address.state],
                ].map(([label, value]) => (
                  <Grid container spacing={1} key={label}>
                    <Grid item xs={5}>
                      <Typography color="text.secondary">{label}:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography fontWeight="medium">{value}</Typography>
                    </Grid>
                  </Grid>
                ))}
              </CardContent>
            </Card>
          </Grid>

          {/* Acciones */}
          <Grid item xs={12} md={4}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <CardContent>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Acciones
                </Typography>
                {data?.status_code == 5 ? <div>Orden de Compta Cancelada</div> :
                  data?.status_code == 2 ?
                    <Grid container spacing={2} mb={2}>
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          onClick={() => handleRelationShips(4)}

                          sx={{ bgcolor: "green", color: "white", width: "100%" }}
                        >
                          AUTORIZAR
                        </Button>
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          onClick={() => handleRelationShips(3)}
                          sx={{ bgcolor: "#ff0033", color: "white", width: "100%" }}
                        >
                          RECHAZAR
                        </Button>
                      </Grid>
                    </Grid> :
                    <div>Acciones no disponibles</div>
                }
                <Typography variant="body2" color="text.secondary">
                  Total del Pedido:
                </Typography>
                <Typography variant="h6" fontWeight="bold">
                  ${Number(totalPedido || 0).toLocaleString()}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Box mt={4}>
          <Typography variant="subtitle1" fontWeight="bold" mb={1}>
            Detalles:
          </Typography>
          <MATERIAL_TABLE_CONTAINER
            columns={columns}
            data={data.details_invoice.concepts}
            modalT={false}
            isLoading={false}
            search_filters={<div></div>}
            component_header={<div></div>}
            file_name_export="Detalles"
            update_identifiers={[]}
          ></MATERIAL_TABLE_CONTAINER>
        </Box>
      </Paper>

    </Box>
  )
}


export default SUPPLIER_INVOICE_DETAIL;